import React from 'react';
import './TabControl.css';

const TabControl = ({ activeTab, onTabChange }) => {
  // 获取收藏数量
  const getFavoriteCount = () => {
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    return favorites.length;
  };

  return (
    <div className="tab-control">
      <button 
        className={`tab-button ${activeTab === 'ranking' ? 'active' : ''}`}
        onClick={() => onTabChange('ranking')}
      >
        排行榜
      </button>
      <button 
        className={`tab-button ${activeTab === 'nearby' ? 'active' : ''}`}
        onClick={() => onTabChange('nearby')}
      >
        附近推荐
      </button>
      <button 
        className={`tab-button ${activeTab === 'weather' ? 'active' : ''}`}
        onClick={() => onTabChange('weather')}
      >
        滑雪天气
      </button>
      <button 
        className={`tab-button ${activeTab === 'favorites' ? 'active' : ''}`}
        onClick={() => onTabChange('favorites')}
      >
        我的收藏
        {getFavoriteCount() > 0 && (
          <span className="favorite-count">{getFavoriteCount()}</span>
        )}
      </button>
    </div>
  );
};

export default TabControl; 